<style lang="scss" scoped>

    .slect_one {
        color: red;
    }

    .no-border {
        border: none;
    }

    .full-width {
        width: 100%;
    }

    .all_subs {
        padding: 0px !important;
        overflow-y: hidden !important;
    }

    .set_nav {
        height: 48px !important;
        margin-bottom: 25px !important;
    }

    .inner_nav_height {
        min-height: 29px !important;
    }

    .home-wrapper .nav {
        min-height: 0px !important;
    }

    .nav-item {
        padding: 0px;
    }

    .side-actions {
        visibility: hidden;
    }

    .wide-btn {
        min-width: 200px;
    }

    .submission-item {
        /*&:hover {*/
        /*    background-color: #f5f8fa;*/
        /*}*/

        .separator {
            /*margin-left: 0.2em;*/
            /*margin-right: 0.2em;*/
            color: #979797;
            font-weight: bold;
        }

        .source {
            color: #979797;
            font-size: 80%;

            &:hover {
                text-decoration: underline;
            }
        }

        border: 1px solid #eaeef5;
        border-bottom: 2px solid #eaeef5;
        border-radius: 2px;
        padding: 0 1em;
        margin-bottom: 0.5em;
        /*background-color: #f5f8fa;*/

        .info {
            color: #979797;
            font-size: 80%;

            a {
                color: #979797;
                font-weight: bold;

                &:hover {
                    text-decoration: underline;
                }
            }
        }

        .title a {
            color: #333;
        }

        .content {
            /*padding: 1em;*/
            padding-right: 0;
            user-select: none;
            padding-bottom: 10px;
            padding-top: 10px;
            // margin-right: 1em;
        }

        .actions {
            margin-top: 1em;

            .left {
                a {
                    font-size: 13px;
                    font-weight: bold;
                    display: inline-flex;
                    align-items: center;
                    min-width: 80px;
                    color: #4c4b4b;
                }
            }

            .right {
                a {
                    font-size: 13px;
                    // font-weight: bold;
                }
            }

            i {
                color: #657786;
                font-size: 17px;
                margin-left: 1em;
            }

            .count {
                margin-left: 1em;
            }

            .date {
                color: #979797;
                font-size: 80%;
                font-weight: normal;

                &:hover {
                    text-decoration: underline;
                }
            }

            .comments-icon:hover {
                i,
                .count {
                    color: #78b38a;
                }
            }

            .bookamrks-icon:hover {
                i {
                    color: #edb431;
                }
            }

            .more-icon:hover {
                i {
                    color: #000;
                }
            }
        }

        .thumbnail {
            border: 1px solid #e3e3e3;
            background-size: cover;
            background-position: center center;
            background-repeat: no-repeat;
            border-radius: 0.2rem;
            height: 125px;
            width: 145px;
        }

        .no-thumbnail {
            border-right: 1px solid #e7e7e7;
        }

        .side-voting {
            padding-right: 1em;

            &:hover {
                cursor: pointer;

                i {
                    color: #db6e6e !important;
                }
            }
        }
    }

    /*.submission-item:hover {*/
    /*    .side-actions {*/
    /*        visibility: inherit;*/
    /*    }*/
    /*}*/

    .set_background_color {
        background-color: #CCCCCC;
        border-radius: 7px;
        padding: 1px 10px;
    }

    .post_info {
        padding: 1px 10px;
    }

    .time_ago {
        font-weight: normal !important;
    }

    .font_weight_noraml {
        font-weight: normal !important;
    }

    .hide_border_p {
        border: none !important;
    }

    .post_images {
        margin-top: 10px;
    }

    .text_to_rgiht {
        text-align: right;
        padding-top: 10px;
    }

    .chanel_da h2 {
        color: #fff;
    }

    .chanel_da {
        color: #fff;
        font-size: 12px;
    }

    .c_v {
        margin-top: 12px;
        margin-bottom: 12px;
    }

    .user-header-right, .channel-header-right {
        flex-basis: 1px !important;
    }

    .pur_p {
        background-color: #8293CA !important;
        color: #fff;
        padding: 10px 12px 14px 12px;
    }

    .home-wrapper .nav {
        min-height: 0px !important;
    }

    .home-wrapper .nav .container {
        min-height: 0px !important;
    }

    .profile-cover {
        min-height: 100px;
        width: 100%;
        border-bottom: 2px solid;
        border-color: rgba(117, 148, 127, 0.24);
        color: #f8f8f8;
        position: relative;
        margin-bottom: 15px;
    }

    .profile-cover-upload-button {
        position: absolute;
        bottom: 1px;
        right: 1px;
    }

    .guest_main {
        margin-top: 45px;
    }

    .set_nav {
        height: 48px !important;
        margin-bottom: 15px !important;
    }

    .htudvc {
        position: relative;
        top: 0px;
        left: 10px;
        background-color: #F0F8FB;
        color: #000;
        border-radius: 0;
    }

    .htuv {
        position: relative;
        left: -10px;
    }

    .htudvm {
        width: 107px;
        background: #F0F8FB;
        text-align: center;
        display: inline-block;
    }

    .dbtm {
        color: #979797;
        padding-left: 20px;
        padding-right: 20px;
        cursor: pointer;
    }

    .location-header {
        background-image: url(/imgs/countrybackground.jpg);
        background-size: cover;
        background-position: center;
        height: 250px;
        display: flex;
    }

    .location-h1 {
        font-size: 40px;
        line-height: 1;
        color: white;
        padding: 0;
        margin: 0;
    }

    .location-avatar {
        width: 120px;
    }

    .location-tagline {
        color: #f3f3f3;
        font-size: 14px !important;
    }

    .location-title-container {
        width: 385px;
        margin-top: 158px;
        background: #000000bd;
        color: white;
        display: flex;
        border-radius: 0px 10px 0px 0px;
    }
</style>
<template>
    <div>
        <!--heeder-->
        <div v-bind:style="{ backgroundImage: `url('${data.cover}')`}"
             class="location-header profile-cover"
             ref="locationCover"
        >
            <!--             :style="{ backgroundImage: `url('${data.cover}')` }"-->

            <div class="user-select">
                <div class="location-title-container">
                    <div class="channel-header-left">
                        <!-- avatar -->
                        <div class="location-avatar">
                            <router-link :to="'/l/' + data.name">
                                <img v-bind:src="data.avatar"/>
                            </router-link>
                        </div>
                        <!-- end avatar -->
                    </div>

                    <div class="channel-header-middle flex-align-center">
                        <div class="chanel_da">
                            <h2 class="location-h1">{{data.name}}</h2>
                            <p class="location-tagline">
                                {{data.tagline}}
                            </p>
                            <!-- <el-button round
                                        @click="$eventHub.$emit('submit')"

                                        size="mini"
                                        class="pur_p">
                                 Submit a post here
                             </el-button>-->
                        </div>

                    </div>

                    <div class="channel-header-right" style="display:none;">
                        <div class="xp">
                            <!--<div class="xp-number">-->
                            <!--{{ Store.page.channel.temp.subscribers_count }}-->
                            <!--</div>-->

                            <!--<div class="xp-text margin-bottom-1">-->
                            <!--Subscribers-->
                            <!--</div>-->
                            <!--                                    <subscribe-->
                            <!--                                               subscribed-class="unsubscribe"-->
                            <!--                                               unsubscribed-class="subscribe"></subscribe>-->
                        </div>


                        <div class="channel-admin-btn">
                            <el-tooltip :content="bookmarked ? 'Unbookmark this channel' : 'Bookmark this channel'"
                                        placement="bottom"
                                        transition="false"
                                        :open-delay="500">
                                <i class="v-icon h-yellow pointer"
                                   :class="bookmarked ? 'go-yellow v-unbookmark' : 'v-bookmark go-gray'"
                                   @click="bookmark"></i>
                            </el-tooltip>

                            <el-dropdown size="medium"
                                         type="primary"
                                         trigger="click"
                                         :show-timeout="0"
                                         :hide-timeout="0">
                                <i class="v-icon v-more-vertical darker-on-hover"></i>

                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="showModeratorsModal = true">
                                        Follow
                                    </el-dropdown-item>

                                    <el-dropdown-item @click.native="showRulesModal = true">
                                        Rules
                                    </el-dropdown-item>

                                    <el-dropdown-item @click.native="block">
                                        Block/Unblock
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <!--<el-button round-->
                            <!--type="success"-->
                            <!--@click="$router.push('/l/' + $route.params.name + '/mod')"-->
                            <!--v-if="isModerator"-->
                            <!--size="mini">-->
                            <!--Moderation-->
                            <!--</el-button>-->

                            <!-- <el-button round
                                        type="warning"
                                        @click="$router.push('/l/' + $route.params.name + '/mod')"
                                        v-if="!isModerator && isHumtogAdministrator"
                                        size="mini">
                                Follow
                             </el-button>-->
                        </div>
                    </div>
                </div>
            </div>

            <div class="profile-cover-upload-button">
                <div v-if="meta.isHumtogAdministrator"
                     class="el-button v-button--upload el-button--default is-plain is-round">
                    <i class="margin-right-half" :class="location.uploading ? 'el-icon-loading' : 'el-icon-upload'"></i>

                    {{ location.uploading ? 'Uploading...' : 'Click To Browse'}}

                    <input class="v-button" type="file" @change="uploadImage"/>
                </div>
            </div>
        </div>
        <!--header end-->
        <div class="h-content">
            <div class="home-wrapper" id="home">
                <div v-if="isLoggedIn" class="nav has-shadow user-select set_nav">
                    <div class="container inner_nav_height">
                        <router-link :to="{name: 'HumTogSubmission', params: { pt: 'text'}, query: { type: 'location', name: $route.params.name} }"
                                     class="el-button wide-btn full-width submit-post-btn">Create a post</router-link>
                        <router-link :to="{name: 'HumTogSubmission', params: { pt: 'img'}, query: { type: 'location', name: $route.params.name } }"
                                     class="el-button headericons v-picture no-border"></router-link>
                        <router-link :to="{name: 'HumTogSubmission', params: { pt: 'link'}, query: { type: 'location', name: $route.params.name } }"
                                     class="el-button headericons v-link no-border"></router-link>
                    </div>
                </div>
                <!--  <location-header></location-header>-->
                <span class="nav has-shadow user-select set_nav"
                      :class="{'shade-item relative': showTour && activeTour.id === 'feed'}">
                    <tour v-if="showTour && activeTour.id == 'feed'"
                          :position="{ top: '7em', left: '39%' }"
                    ></tour>
                    <div class="container inner_nav_height">
                        <div class="nav-left">
                            <router-link :to="{ path: '/l/' + $route.params.name }"
                                         class="nav-item is-tab" :class="{ 'is-active': sort === 'all' }">
                                All
                            </router-link>
                            <router-link :to="{ path: '/l/' + $route.params.name + '?sort=serious' }"
                                         class="nav-item is-tab" :class="{ 'is-active': sort === 'serious' }">
                                Serious
                            </router-link>
                          <router-link :to="{ path: '/l/' + $route.params.name + '?sort=relaxed' }"
                                       class="nav-item is-tab" :class="{ 'is-active': sort === 'relaxed' }">
                              Relaxed
                          </router-link>
                        </div>

                        <!--<el-tooltip content="Scroll to top" placement="bottom" transition="false" :open-delay="500">-->
                        <!--<img src="/imgs/Humtog.png" class="logo" alt="Humtog" @click="scrollToTop('submissions')">-->
                        <!--</el-tooltip>-->

                        <div class="flex-center">
                            <el-tooltip content="Refresh (R)" placement="bottom" transition="false"
                                        :open-delay="500">
                                <button class="feed-panel-button" @click="refresh">
                                    <i class="el-icon-refresh" :class="{'rotate': refreshing}"></i>
                                </button>
                            </el-tooltip>

                            <el-tooltip v-if="isLoggedIn" content="Turn on to only show subscribed">
                                <el-switch v-model="showSubscription"></el-switch>
                            </el-tooltip>
                        </div>
                    </div>
                </span>

                <section id="submissions"
                         class="home-submissions all_subs"
                         :class="{'flex-center' : nothingFound}"
                         v-infinite-scroll="loadMore"
                         infinite-scroll-distance="200"
                         infinite-scroll-disabled="cantLoadMore"
                         @scroll.passive="scrolled">
                    <div v-for="(submission, index) in submissions" :key="submission.id">
                        <submission :lightbox="true" :list="submission"></submission>
                    </div>

                    <loading v-if="loading && page > 1"></loading>
                    <no-more-items
                            v-if="NoMoreItems && !nothingFound"
                            :text="'No more items to load'"
                    ></no-more-items>
                </section>
            </div>
        </div>

        <div class="h-sidebar">
            <div class="sidebar-right user-select comtt_c">
                <el-card class="box-card humtog_s">
                    <h2 class="community_chanel">{{data.name}}</h2>
                    <p>{{data.description}}</p>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
    import Helpers from '../mixins/Helpers'
    import Submission from '../components/Submission.vue'
    import SuggestedChannel from '../components/SuggestedChannel.vue'
    import Loading from '../components/Loading.vue'
    import NoContent from '../components/NoContent.vue'
    import NoMoreItems from '../components/NoMoreItems.vue'
    import HomeSidebar from '../components/sidebars/HomeSidebar.vue'
    import Tour from '../components/Tour'
    import locationHeader from '../components/LocationHeader'
    import Moderators from '../components/Moderators.vue'
    import SubmissionPageContent from './SubmissionPageContent'

    export default {
        mixins: [Helpers],

        components: {
            locationHeader,
            Submission,
            Moderators,
            Loading,
            SuggestedChannel,
            NoContent,
            NoMoreItems,
            Tour,
            HomeSidebar,
            SubmissionPageContent
        },

        data() {
            return {
                refreshing: false,
                data: '',
                locationName: '',
                bookmarked: false,
                location: {
                    fileUploadFormData: new FormData(),
                    uploading: false,
                    errors: []
                },
                showSubscription: false,
                showSubscribed: 'all'
            }
            // sort:'serious'
        },
        watch: {
            '$route.query.sort'(newvalue) {
                this.sort = newvalue
                this.getLocation()
            },

            $route() {
                this.$Progress.start();

                this.showSubscription = false;
                this.showSubscribed = 'all';

                this.$eventHub.$emit("refresh-home", this.refresh);

                this.$Progress.finish();
            },

            showSubscription(val) {
                if (val) {
                    this.showSubscribed = 'subscribed'
                    this.$eventHub.$emit("refresh-home", this.refresh);

                } else {
                    this.showSubscribed = 'all'
                    this.$eventHub.$emit("refresh-home", this.refresh);
                }
            },
        },

        created() {
            this.$Progress.start();
            this.getLocation();

            this.showSubscription = false;
            this.showSubscribed = 'all';

            Store.page.locationFeed.clear();

            Store.page.locationFeed.getSubmissions(this.sort, this.$route.params.name, this.showSubscribed);

            this.$eventHub.$on("refresh-home", this.refresh);

            this.$Progress.finish();
        },

        beforeDestroy() {
            this.$eventHub.$off("refresh-home", this.refresh);
        },

        computed: {
            thumbnail() {
                if (this.type === 'News') {
                    return {
                        backgroundImage: 'url(' + this.list.content.thumbnail_path + ')'
                    }
                } else if (this.type === 'img') {
                    return {
                        backgroundImage: 'url(' + this.list.content.thumbnail_path + ')'
                    }
                }
            },
            cantLoadMore() {
                return this.loading || this.NoMoreItems || this.nothingFound
            },

            NoMoreItems() {
                return Store.page.locationFeed.NoMoreItems
            },

            nothingFound() {
                return Store.page.locationFeed.nothingFound
            },

            submissions() {
                return Store.page.locationFeed.submissions
            },

            loading() {
                return Store.page.locationFeed.loading
            },

            sort() {
                return this.$route.query.sort ? this.$route.query.sort : 'all'
            },

            page() {
                return Store.page.locationFeed.page
            },

            uniqueList() {
                return _.uniqBy(this.submissions, 'id')
            }
        },

        methods: {
            uploadImage(e) {
                this.location.uploading = true
                this.location.errors = []
                this.location.fileUploadFormData = new FormData()

                this.location.fileUploadFormData.append('photo', e.target.files[0])

                axios
                    .post(`/location/${this.$route.params.name}/photo`, this.location.fileUploadFormData)
                    .then((response) => {
                        this.location.uploading = false
                        if (response.data) {
                            this.data.cover = response.data
                        }
                    })
                    .catch((error) => {
                        this.location.errors = error.response.data.errors
                        this.location.uploading = false
                    })
            },
            minimize(text) {
                return text.substring(0, 200) // simply delegating to the global function
            },

            getLocation() {
                let url = '/feed/location/?location=' + this.$route.params.name
                if (this.sort) {
                    url += '&sort=' + this.sort
                }
                axios.get(url, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then((response) => {
                    this.data = response.data.data
                    if (!this.data.cover) {
                        this.data.cover = '/imgs/countrybackground.jpg'
                    }

                }).catch((error) => {

                })

            },
            loadMore() {
                console.log('load more')
                Store.page.locationFeed.getSubmissions(this.sort, this.$route.params.name)
            },

            refresh: _.debounce(
                function () {
                    this.refreshing = true

                    this.getLocation()

                    Store.page.locationFeed.clear();

                    Store.page.locationFeed.getSubmissions(this.sort, this.$route.params.name, this.showSubscribed);

                    this.refreshing = false
                },
                200,
                {leading: true, trailing: false}
            ),

            submit() {
                this.$eventHub.$emit('submit')
            },
            showThumbnail(data) {
                return data || data
            },
            embedOrOpen(event) {
                if (this.type === 'News') {
                    this.$router.push(this.url)
                }

                if (this.type === 'img') {
                    this.showPhotoViewer(this.list.content)
                }
            },

            startTour() {
                if (this.$route.query.newbie == 1) {
                    Store.tour.show = true
                }
            },
            bookmark: _.debounce(
                function () {
                    if (this.isGuest) {
                        this.mustBeLogin()
                        return
                    }

                    this.bookmarked = !this.bookmarked

                    axios.post(`/channels/${Store.page.channel.temp.id}/bookmark`).catch(() => {
                        this.bookmarked = !this.bookmarked
                    })
                },
                200,
                {leading: true, trailing: false}
            ),
            coverBackground() {
                if (Store.page.channel.temp.cover_color == 'Red') {
                    return '#9a4e4e'
                } else if (Store.page.channel.temp.cover_color == 'Blue') {
                    return 'rgb(244, 245, 247)'
                } else if (Store.page.channel.temp.cover_color == 'Dark Blue') {
                    return '#2f3b49'
                } else if (Store.page.channel.temp.cover_color == 'Dark Green') {
                    return '#507e75'
                } else if (Store.page.channel.temp.cover_color == 'Bright Green') {
                    return 'rgb(117, 148, 127)'
                } else if (Store.page.channel.temp.cover_color == 'Purple') {
                    return '#4d4261'
                } else if (Store.page.channel.temp.cover_color == 'Orange') {
                    return '#ffaf40'
                } else if (Store.page.channel.temp.cover_color == 'Pink') {
                    return '#ec7daa'
                } else {
                    // userStore.cover_color == 'Black'
                    return '#424242'
                }
            }
        }

    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/LocationComponent.vue